import React, { Component } from 'react';
import { Provider,connect } from 'react-redux';
import store from '../store.js'
import App from "./App";

class Root extends Component{
        render() {
            return (
                <Provider store={ store }>
                    <App />
                </Provider>
            )
        }
}

export default Root;


// WEBPACK FOOTER //
// ./src/components/Root.js